import TextsmsIcon from '@material-ui/icons/Textsms';
import InboxIcon from '@material-ui/icons/Inbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import AppsIcon from '@material-ui/icons/Apps';

export const sidebarItemsData = [
    {
        icon: <TextsmsIcon/>,
        text:"Thread"
    },

    {
        icon: <InboxIcon/>,
        text:"All DMs"
    },

    {
        icon: <DraftsIcon/>,
        text:"Mentions & Reactions"
    },

    {
        icon: <BookmarkBorderIcon/>,
        text:"Save Items"
    },

    {
        icon: <PeopleOutlineIcon/>,
        text:"More"
    },

    {
        icon: <AppsIcon/>,
        text:"More"
    },

    
]